import { render, staticRenderFns } from "./ProductContributor.vue?vue&type=template&id=06800f24&"
import script from "./ProductContributor.vue?vue&type=script&lang=js&"
export * from "./ProductContributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports